import * as types from '../constants/jobsConstants';

const initialState = {};

export default function jobs(state = initialState, action) {
  switch(action.type) {
  case types.GET_JOBS_SUCCESS:
    return Object.assign({}, state, action.response);
  default:
    return state;
  }
}



// WEBPACK FOOTER //
// ./app/jobs/reducers/jobs.js